import api from './api';

export const getListProperty = async () => {
  interface TypeSelectData {
    _id: string;
    name: string;
  }

  interface TypePropertyData {
    _id: string;
    name: string;
    natureza: TypeSelectData[];
  }

  const list: TypePropertyData[] = [
    {
      _id: 'Automóvel',
      name: 'Automóvel',
      natureza: [
        { _id: 'Colisão', name: 'Colisão' },
        { _id: 'Roubo', name: 'Roubo' },
        { _id: 'Furto', name: 'Furto' },
        { _id: 'Incêndio', name: 'Incêndio' },
        { _id: 'Grânizo', name: 'Grânizo' },
        { _id: 'Acidente', name: 'Acidente' },
        {
          _id: 'Responsabilidade Civil Facultativa de Veículos – RCF-V',
          name: 'Responsabilidade Civil Facultativa de Veículos – RCF-V',
        },
        {
          _id:
            'Acidentes Pessoais de Passageiros – Morte e Invalidez Permanente – APP',
          name:
            'Acidentes Pessoais de Passageiros – Morte e Invalidez Permanente – APP',
        },
      ],
    },
    {
      _id: 'Moto',
      name: 'Moto',
      natureza: [
        { _id: 'Colisão', name: 'Colisão' },
        { _id: 'Roubo', name: 'Roubo' },
        { _id: 'Furto', name: 'Furto' },
        { _id: 'Incêndio', name: 'Incêndio' },
        { _id: 'Grânizo', name: 'Grânizo' },
        { _id: 'Acidente', name: 'Acidente' },
        {
          _id: 'Responsabilidade Civil Facultativa de Veículos – RCF-V',
          name: 'Responsabilidade Civil Facultativa de Veículos – RCF-V',
        },
        {
          _id:
            'Acidentes Pessoais de Passageiros – Morte e Invalidez Permanente – APP',
          name:
            'Acidentes Pessoais de Passageiros – Morte e Invalidez Permanente – APP',
        },
      ],
    },
    {
      _id: 'Eletronicos e portáteis',
      name: 'Eletronicos e portáteis',
      natureza: [
        { _id: 'Garantia Estendida', name: 'Garantia Estendida' },
        {
          _id: 'Reparo de danos acidentais',
          name: 'Reparo de danos acidentais',
        },
        { _id: 'Roubo Qualificado', name: 'Roubo Qualificado' },
        { _id: 'Furto Qualificado', name: 'Furto Qualificado' },
      ],
    },
    {
      _id: 'Residencial',
      name: 'Residencial',
      natureza: [
        {
          _id: 'Danos Físicos ao Imóvel (DFI)',
          name: 'Danos Físicos ao Imóvel (DFI)',
        },
        {
          _id: 'Morte e Invalidez Permanente (MIP)',
          name: 'Morte e Invalidez Permanente (MIP)',
        },
        {
          _id: 'Responsabilidade Civil do Construtor (RCC)',
          name: 'Responsabilidade Civil do Construtor (RCC)',
        },
      ],
    },
    {
      _id: 'Vida',
      name: 'Vida',
      natureza: [
        { _id: 'Morte', name: 'Morte' },
        { _id: 'Morte Acidental', name: 'Morte Acidental' },
        {
          _id: 'Invalidez Permanente Total por acidente',
          name: 'Invalidez Permanente Total por acidente',
        },
        {
          _id: 'Invalidez Permanente Parcial por acidente',
          name: 'Invalidez Permanente Parcial por acidente',
        },
        {
          _id: 'Invalidez funcional por doença funcional',
          name: 'Invalidez funcional por doença funcional',
        },
        {
          _id: 'Indenização especial por cirurgia',
          name: 'Indenização especial por cirurgia',
        },
        {
          _id: 'Diagnóstico de Câncer Feminino',
          name: 'Diagnóstico de Câncer Feminino',
        },
        {
          _id: 'Diagnóstico de Câncer Masculino',
          name: 'Diagnóstico de Câncer Masculino',
        },
        { _id: 'Doenças Graves', name: 'Doenças Graves' },
        {
          _id: 'Diária de Internação Hospitalar',
          name: 'Diária de Internação Hospitalar',
        },
        {
          _id:
            'Diária de Internação Hospitalar em Unidade Intensiva de Tratamento',
          name:
            'Diária de Internação Hospitalar em Unidade Intensiva de Tratamento',
        },
        {
          _id: 'Despesas Médicas Hospitalares e Odontológicas por Acidente',
          name: 'Despesas Médicas Hospitalares e Odontológicas por Acidente',
        },
        { _id: 'Funeral Familiar', name: 'Funeral Familiar' },
      ],
    },
    {
      _id: 'Transporte',
      name: 'Transporte',
      natureza: [],
    },
    {
      _id: 'FiancaLocaticia',
      name: 'Fiança Locatícia',
      natureza: [],
    },
    {
      _id: 'Bike',
      name: 'Bike (Bicicleta)',
      natureza: [],
    },
  ];

  return list;
};
